/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * A header an auth client sends upstream. Exactly one of value and value_from_request_header is set, except that a header already storing a value may omit both to keep it, as long as is_secret is unchanged.
 */
export type AuthClientHeaderInput = {
  /**
   * What the header is for.
   */
  description?: string | undefined;
  /**
   * Whether a caller must supply the header when it is copied from the request.
   */
  isRequired?: boolean | undefined;
  /**
   * Whether the value is secret. Secret values are stored encrypted and never returned.
   */
  isSecret?: boolean | undefined;
  /**
   * The header name.
   */
  name: string;
  /**
   * The value to send. Omit it on a header that already stores one, with is_secret unchanged, to keep the stored value.
   */
  value?: string | undefined;
  /**
   * The caller's request header to copy the value from, for pass-through headers.
   */
  valueFromRequestHeader?: string | undefined;
};

/** @internal */
export type AuthClientHeaderInput$Outbound = {
  description?: string | undefined;
  is_required: boolean;
  is_secret: boolean;
  name: string;
  value?: string | undefined;
  value_from_request_header?: string | undefined;
};

/** @internal */
export const AuthClientHeaderInput$outboundSchema: z.ZodMiniType<
  AuthClientHeaderInput$Outbound,
  AuthClientHeaderInput
> = z.pipe(
  z.object({
    description: z.optional(z.string()),
    isRequired: z._default(z.boolean(), false),
    isSecret: z._default(z.boolean(), false),
    name: z.string(),
    value: z.optional(z.string()),
    valueFromRequestHeader: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      isRequired: "is_required",
      isSecret: "is_secret",
      valueFromRequestHeader: "value_from_request_header",
    });
  }),
);

export function authClientHeaderInputToJSON(
  authClientHeaderInput: AuthClientHeaderInput,
): string {
  return JSON.stringify(
    AuthClientHeaderInput$outboundSchema.parse(authClientHeaderInput),
  );
}
